import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const INPUT = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.Tenant.Input,
    graphql.schema.TenantInput
  >({
    alias: transformers.PASS_THROUGH,
    code: transformers.PASS_THROUGH,
    color: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
  }),
)

export const UPDATES = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.admin.Tenant.Updates,
    graphql.schema.TenantUpdates
  >({
    alias: transformers.PASS_THROUGH,
    code: transformers.PASS_THROUGH,
    color: transformers.PASS_THROUGH,
    name: transformers.PASS_THROUGH,
  }),
)
